import React from 'react';
import { getPrimaryTier } from '../../DeviationViews/_helpers';
export const PrimaryTierContext = /*#__PURE__*/ React.createContext({
    primaryTier: undefined
});
PrimaryTierContext.displayName = 'PrimaryTierContext';
export const PrimaryTierContextProvider = ({ primaryTier , children  })=>/*#__PURE__*/ React.createElement(PrimaryTierContext.Provider, {
        value: {
            primaryTier
        }
    }, children);
PrimaryTierContextProvider.displayName = 'PrimaryTierContextProvider';
export function usePrimaryTier(deviation) {
    const { primaryTier: contextualTier  } = React.useContext(PrimaryTierContext);
    return contextualTier || getPrimaryTier(deviation);
}
